import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";
import { Box } from "@mui/system";
import { DataGridPro, GridColDef } from "@mui/x-data-grid-pro";
import { useState } from "react";
import { useSelector } from "react-redux";

const OtherModalForIdenticalKeyword = ({ open, onClose }: any) => {
  const { otherNonNegativeAdgroupsForIdenticalToExactKeyword } = useSelector(
    (state: any) => state.searchTermTab
  );

  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 10,
  });

  // --- Define columns ---
  const columns: GridColDef[] = [
    {
      field: "non_negative_in_ad_group_name",
      headerName: "Adgroup Name",
      flex: 1,
      minWidth: 200,
    },
  ];

  return (
    <Dialog
      open={open}
      onClose={(_, reason) => {
        // Prevent close if loading and the reason is backdrop click or escape key
        if (reason === "backdropClick" || reason === "escapeKeyDown") {
          return;
        }
        onClose();
      }}
      maxWidth="md"
      fullWidth
    >
      <DialogTitle>
        Other Non-Negative Adgroups Related to the Search term:{" "}
        {otherNonNegativeAdgroupsForIdenticalToExactKeyword.length > 0 &&
          otherNonNegativeAdgroupsForIdenticalToExactKeyword[0].search_term}
      </DialogTitle>
      <DialogContent>
        <Box sx={{ width: "100%", display: "grid" }}>
          <DataGridPro
            sx={dataGridStyles}
            density="compact"
            // hideFooter
            pagination
            paginationModel={paginationModel}
            onPaginationModelChange={setPaginationModel}
            pageSizeOptions={[10, 25, 100]}
            rows={otherNonNegativeAdgroupsForIdenticalToExactKeyword}
            columns={columns}
            disableColumnMenu
            disableColumnFilter
            disableColumnReorder
            sortingOrder={["asc", "desc"]}
            isCellEditable={() => false}
            disableRowSelectionOnClick
          />
        </Box>
      </DialogContent>
      <DialogActions sx={{ padding: "0px 20px 16px" }}>
        <Button color="secondary" variant="outlined" onClick={onClose}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default OtherModalForIdenticalKeyword;
// === Shared DataGrid Styles ===
const dataGridStyles = {
  "& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within": {
    outline: "none",
  },
  "& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within":
    { outline: "none" },
  "& .MuiDataGrid-cellEmpty": {
    width: "auto",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },

  // row selection only once
  "& .MuiDataGrid-row.Mui-selected": {
    backgroundColor: "rgba(156, 39, 176, 0.08) !important",
    "&:hover": {
      backgroundColor: "rgba(156, 39, 176, 0.16) !important",
    },
  },

  "& .MuiDataGrid-row.Mui-selected .MuiDataGrid-cell--pinnedLeft": {
    backgroundColor: "#f0def3 !important",
  },
  "& .MuiDataGrid-row.Mui-selected:hover .MuiDataGrid-cell--pinnedLeft": {
    backgroundColor: "#e6d6e9ff !important",
  },

  // pinned RIGHT
  "& .MuiDataGrid-row.Mui-selected .MuiDataGrid-cell--pinnedRight": {
    backgroundColor: "#f0def3 !important",
  },
  "& .MuiDataGrid-row.Mui-selected:hover .MuiDataGrid-cell--pinnedRight": {
    backgroundColor: "#e6d6e9ff !important",
  },
  // make pinned cells transparent → let row bg show through
  "& .MuiDataGrid-cell--pinnedLeft, & .MuiDataGrid-cell--pinnedRight": {
    backgroundColor: "#ffffff",
  },

  // remove extra blue tint on single cell select
  "& .MuiDataGrid-cell.Mui-selected": {
    backgroundColor: "inherit !important",
  },

  "& .MuiCheckbox-root": {
    color: "#9c27b0 !important",
  },
  "& .MuiCheckbox-root.Mui-checked": {
    color: "#9c27b0",
  },
  border: "none",
};
